import { UserRoleEnum } from '@enums/user-role.enum';

/** Dialog width matching the legacy checklist details overlay (`100rem`). */
export const CHECK_LIST_DETAILS_MODAL_WIDTH = '100rem';

/** Diameter of the centered loading spinner in the checklist details body. */
export const CHECK_LIST_DETAILS_SPINNER_DIAMETER_PX = 48;

/** Date format used by the legacy checklist details table. */
export const CHECK_LIST_DETAILS_DATE_FORMAT = 'MM:dd:yy hh:mm';

/** Success toast duration used by the legacy checklist update. */
export const CHECK_LIST_DETAILS_SUCCESS_TIMEOUT_MS = 2000;

/** Warning toast duration used by the legacy checklist load/save errors. */
export const CHECK_LIST_DETAILS_WARNING_TIMEOUT_MS = 6000;

/** Roles allowed to toggle and save checklist completion. */
export const CHECK_LIST_DETAILS_EDITABLE_ROLES: readonly UserRoleEnum[] = [
  UserRoleEnum.COORDINATOR,
  UserRoleEnum.MANAGEMENT,
  UserRoleEnum.EXECUTIVE_ADMIN,
];

/** Column ids for the checklist details `mat-table`. */
export const CHECK_LIST_DETAILS_TABLE_COLUMN = {
  SERIAL: 'serialNumber',
  ITEM: 'itemName',
  LAST_UPDATED_BY: 'lastUpdatedByName',
  LAST_UPDATED_ON: 'lastUpdatedOn',
  COMPLETED: 'isChecked',
} as const;

export type CheckListDetailsTableColumn = (typeof CHECK_LIST_DETAILS_TABLE_COLUMN)[keyof typeof CHECK_LIST_DETAILS_TABLE_COLUMN];

/** Displayed column order for the checklist details table. */
export const CHECK_LIST_DETAILS_DISPLAYED_COLUMNS: readonly CheckListDetailsTableColumn[] = [
  CHECK_LIST_DETAILS_TABLE_COLUMN.SERIAL,
  CHECK_LIST_DETAILS_TABLE_COLUMN.ITEM,
  CHECK_LIST_DETAILS_TABLE_COLUMN.LAST_UPDATED_BY,
  CHECK_LIST_DETAILS_TABLE_COLUMN.LAST_UPDATED_ON,
  CHECK_LIST_DETAILS_TABLE_COLUMN.COMPLETED,
];
